import { Platform } from "react-native";

import { Flag } from "@medbillai/utils/flag";

import { useBoolVariation } from "./flag";

export type InAppBrowser = "facebook" | "instagram" | "threads" | "none";

export function getInAppBrowser(): InAppBrowser {
  if (Platform.OS !== "web" || typeof navigator === "undefined") {
    return "none";
  }
  const ua = navigator.userAgent;
  if (ua.includes("Barcelona")) {
    return "threads";
  }
  if (ua.includes("Instagram")) {
    return "instagram";
  }
  if (ua.includes("FBAN") || ua.includes("FBAV") || ua.includes("FB_IAB")) {
    return "facebook";
  }
  return "none";
}

/**
 * Whether email login should lead with a link that opens in any browser.
 * A Meta in-app browser's storage never reaches Safari, so only a link without
 * PKCE carries the member out signed in.
 */
export const useMetaWebviewLinkLogin = (): boolean => {
  const enabled = useBoolVariation(Flag.META_WEBVIEW_LINK_LOGIN, false);
  return enabled && getInAppBrowser() !== "none";
};

/**
 * Nobody is signed into Google or Apple inside an in-app browser, so signing in
 * there again costs more than typing an email.
 */
export const canOfferProviderSignIn = (): boolean =>
  getInAppBrowser() === "none";

export const useNateraIntakeOAuth = (): boolean => {
  const enabled = useBoolVariation(Flag.NATERA_INTAKE_OAUTH, false);
  return enabled && Platform.OS === "web" && canOfferProviderSignIn();
};
